import Button from '@/components/Button'
import Icon from '@/components/Icon'
import { faArrowRight, faChevronLeft, faChevronRight } from '@fortawesome/sharp-solid-svg-icons'
import dynamic from 'next/dynamic'

import styles from './Posts.module.scss'

// Swiper only runs in the browser, so load it after hydration instead of with the page
const PostsSlider = dynamic(() => import('./PostsSlider'), { ssr: false })

function Posts({ posts, id }) {
  return (
    <section {...(id && { id })} className={styles.posts} data-cy="featured-blog-posts-section">
      <div className={styles.headingSection} data-aos="fade-up">
        <div className={styles.headingSectionOne}>
          <p className={styles.eyebrowText}>STAY UP TO DATE</p>
          <h2 className={styles.heading} data-cy="featured-blog-posts-title">
            The latest from Integrity
          </h2>
        </div>
        <div className={styles.headingSectionTwo}>
          <Button href="/blog">
            View All posts <Icon icon={faArrowRight} />
          </Button>
        </div>
      </div>

      <div className={styles.sliderContainer} data-aos="fade-up">
        <PostsSlider posts={posts} />

        <div className="prev-btn">
          <Icon icon={faChevronLeft} />
        </div>
        <div className="next-btn">
          <Icon icon={faChevronRight} />
        </div>
      </div>
    </section>
  )
}

export default Posts
